export enum parameterType {
  STATION = "STATION",
  SAMPLINGPOINT = "SAMPLINGPOINT",
}

export enum parameterSubtype {
  OPERATIONAL = "OPERATIONAL",
  ENVIRONMENTAL = "ENVIRONMENTAL",
  QUALITY = "QUALITY",
  QUANTITY = "QUANTITY",
  METEOROLOGY = "METEOROLOGY",
  DATA_IMAGE = "DATA_IMAGE",
  FLOATING = "FLOATING",
  TMOA = "TMOA",
}

export interface Parameter {
  id: number | undefined;
  name: string | undefined;
  code: string | undefined;
  codeFTP: string | undefined;
  instrumentationRange: number[] | undefined;
  physicalRange: number[] | undefined | null;
  unit: string | undefined;
  abbreviation: string | undefined;
  type: parameterType;
  subtype: parameterSubtype | undefined;
  active?: boolean;
  client: boolean;
}
